import { render, staticRenderFns } from "./the-delivery.vue?vue&type=template&id=019682c2&scoped=true"
import script from "./the-delivery.vue?vue&type=script&lang=js"
export * from "./the-delivery.vue?vue&type=script&lang=js"
import style0 from "./the-delivery.vue?vue&type=style&index=0&id=019682c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019682c2",
  null
  
)

export default component.exports